import { FC } from 'react';

import { ITextFieldWithPrefixHelperTextProps } from './TextFieldWithPrefixHelperText.types';

export const TextFieldWithPrefixHelperText: FC<ITextFieldWithPrefixHelperTextProps> = (props) => {
  const {
    isValidating = false,
    validatingText,
    hasError = false,
    errorText,
    hasSuccess = false,
    successText,
    helperText,
  } = props;

  if (isValidating) {
    return <>{validatingText}</>;
  }

  if (hasError) {
    return <>{errorText}</>;
  }

  if (hasSuccess) {
    return <>{successText}</>;
  }

  if (helperText) {
    return <>{helperText}</>;
  }

  return null;
};
